export default "__VITE_ASSET__DR7vzoX2__"